export default __webpack_public_path__ + "static/media/15.c38d86ec.webp";